import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';

const pages = ['Skills', 'Experience', 'Projects', 'Education'];

const Header = () => {
  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Avatar src='https://avatars.githubusercontent.com/u/240517?v=4' style={{marginRight: '16px'}} />
          <h3>Douglas E. Reisinger II</h3>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Link
                className='nav-link'
                key={page}
                underline='none'
                href={`#${page.toLowerCase()}`}
              >
                {page}
              </Link>
            ))}
          </Box>
          <Box className='resource-links'>
              <Tooltip title='Download Resume' placement='bottom'>
                <Link underline='none' target='none' href='/Resume.pdf' download><DownloadForOfflineIcon /></Link>
              </Tooltip>
              <Tooltip title="View my GitHub Profile" placement='bottom'>
                <Link underline='none' target='none' href='https://github.com/palodequeso'><GitHubIcon /></Link>
              </Tooltip>
              <Tooltip title="View my LinkedIn Profile" placement='bottom'>
                <Link underline='none' target='none' href='https://www.linkedin.com/in/douglas-e-reisinger-ii-a4060483/'><LinkedInIcon /></Link>
              </Tooltip>
              <Tooltip title="Email me" placement='bottom'>
                <Link underline='none' target='none' href='mailto:palodequeso@gmail.com'><EmailIcon /></Link>
              </Tooltip>
              <Tooltip title="Call me" placement='bottom'>
                <Link underline='none' target='none' href='tel:+17173647434'><PhoneIcon /></Link>
              </Tooltip>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
